import { render, staticRenderFns } from "./CustomFieldModal.vue?vue&type=template&id=0bd99aa9&"
import script from "./CustomFieldModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports